"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOptimizedSrc = void 0;

var _react = require("react");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useOptimizedSrc = function useOptimizedSrc(_ref) {
  var _image$dimension, _image$dimension2;

  var image = _ref.image,
      dimensions = _ref.dimensions,
      quality = _ref.quality,
      pixelRatio = _ref.pixelRatio,
      _ref$crop = _ref.crop,
      crop = _ref$crop === void 0 ? false : _ref$crop,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug,
      offsetX = _ref.offsetX,
      offsetY = _ref.offsetY,
      fit = _ref.fit; // src default to the smallest transparent image, to avoid flashing broken image icons.

  var _useState = (0, _react.useState)("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\"/>"),
      _useState2 = _slicedToArray(_useState, 2),
      src = _useState2[0],
      setSrc = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentWidth = _useState4[0],
      setCurrentWidth = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentHeight = _useState6[0],
      setCurrentHeight = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = _slicedToArray(_useState7, 2),
      aspectRatio = _useState8[0],
      setAspectRatio = _useState8[1];

  var imgWidth = (_image$dimension = image.dimension) === null || _image$dimension === void 0 ? void 0 : _image$dimension.width;
  var imgHeight = (_image$dimension2 = image.dimension) === null || _image$dimension2 === void 0 ? void 0 : _image$dimension2.height;
  var dimensionWidth = dimensions === null || dimensions === void 0 ? void 0 : dimensions.width;
  var dimensionHeight = dimensions === null || dimensions === void 0 ? void 0 : dimensions.height; // Handy dandy debugging useEffect dependencies:

  useWhatChanged(debug, "dimensions", {
    currentHeight: currentHeight,
    currentWidth: currentWidth,
    dimensionWidth: dimensionWidth,
    dimensionHeight: dimensionHeight,
    imgHeight: imgHeight,
    imgWidth: imgWidth,
    pixelRatio: pixelRatio
  }); // Calculate desired width and height

  (0, _react.useEffect)(function () {
    var _ref2;

    var parentWidth = dimensionWidth ? Math.round(dimensionWidth) : undefined;
    var parentHeight = dimensionHeight ? Math.round(dimensionHeight) : undefined;
    setAspectRatio(imgWidth && imgHeight ? Math.round(imgWidth / imgHeight * 100) / 100 : 0);
    var usePixelRatio = (_ref2 = pixelRatio !== null && pixelRatio !== void 0 ? pixelRatio : window.devicePixelRatio) !== null && _ref2 !== void 0 ? _ref2 : 1;
    if (!parentWidth && !parentHeight) return;
    var calcWidth = Math.round(Math.min(parentWidth !== null && parentWidth !== void 0 ? parentWidth : 0, imgWidth !== null && imgWidth !== void 0 ? imgWidth : Infinity) * usePixelRatio);
    var calcHeight = Math.round(Math.min(parentHeight !== null && parentHeight !== void 0 ? parentHeight : 0, imgHeight !== null && imgHeight !== void 0 ? imgHeight : Infinity) * usePixelRatio);

    if (!currentWidth || calcWidth && calcWidth > currentWidth) {
      setCurrentWidth(calcWidth);
    }

    if (!currentHeight || calcHeight && calcHeight > currentHeight) {
      setCurrentHeight(calcHeight);
    }
  }, [currentHeight, currentWidth, dimensionWidth, dimensionHeight, imgHeight, imgWidth, pixelRatio]);
  useWhatChanged(debug, "src", {
    "image.url": image.url,
    quality: quality,
    crop: crop,
    aspectRatio: aspectRatio,
    currentHeight: currentHeight,
    currentWidth: currentWidth,
    offsetX: offsetX,
    offsetY: offsetY
  }); // Calculate image src

  (0, _react.useEffect)(function () {
    if (!currentWidth && !currentHeight) return;

    if (debug) {
      console.log({
        aspectRatio: aspectRatio,
        currentWidth: currentWidth,
        currentHeight: currentHeight,
        devicePixelRatio: devicePixelRatio,
        chAspect: aspectRatio ? currentHeight * aspectRatio : undefined
      });
    }

    var params = ["auto=webp", "disable=upscale"];

    if (quality) {
      params.push("quality=".concat(quality));
    }

    if (currentWidth && currentHeight) {
      if (!aspectRatio && !crop) {
        if (fit === "height") {
          params.push("height=".concat(currentHeight));
        } else {
          params.push("width=".concat(currentWidth));
        }
      } else if (crop) {
        params.push("height=".concat(currentHeight));
        params.push("width=".concat(currentWidth));
        var offsetCrop = [offsetX !== undefined && offsetX !== null ? "offset-x".concat(offsetX) : null, offsetY !== undefined && offsetY !== null ? "offset-y".concat(offsetY) : null].filter(function (o) {
          return o;
        }).join(",");
        var offsetString = offsetCrop ? ",".concat(offsetCrop) : "";
        var cropString = "".concat(currentWidth, ":").concat(currentHeight).concat(offsetString);
        params.push("crop=".concat(cropString));
      } else if (currentWidth + 1 >= currentHeight * aspectRatio) {
        params.push("width=".concat(currentWidth));
      } else {
        params.push("height=".concat(currentHeight));
      }
    } else if (currentWidth) {
      params.push("width=".concat(currentWidth));
    } else if (currentHeight) {
      params.push("height=".concat(currentHeight));
    }

    var urlParams = params.join("&");
    var newSrc = "".concat(image.url, "?").concat(urlParams);
    setSrc(newSrc);
  }, [image.url, quality, crop, aspectRatio, currentHeight, currentWidth, offsetX, offsetY, fit, debug]);
  useWhatChanged(debug, "src changed!", {
    src: src
  });
  return src;
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


exports.useOptimizedSrc = useOptimizedSrc;

function useWhatChanged(debug, label, deps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var _useState9 = (0, _react.useState)({}),
      _useState10 = _slicedToArray(_useState9, 2),
      prev = _useState10[0],
      setPrev = _useState10[1];

  (0, _react.useEffect)(function () {
    if (!debug) return;
    var prevEntries = Object.entries(prev);
    var depsEntries = Object.entries(deps);

    if (prevEntries.length !== depsEntries.length) {
      console.log("[".concat(label, "] Array length changed!"));
    }

    var diff = depsEntries // Find difference
    .filter(function (_ref3, i) {
      var _prevEntries$i, _depsEntries$i;

      var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];

      return ((_prevEntries$i = prevEntries[i]) === null || _prevEntries$i === void 0 ? void 0 : _prevEntries$i[0]) !== ((_depsEntries$i = depsEntries[i]) === null || _depsEntries$i === void 0 ? void 0 : _depsEntries$i[0]) || !Object.is(prev[k], v);
    });

    if (diff.length) {
      console.log("[".concat(label, "] Item(s) changed:"));
      console.table(diff);
    }

    setPrev(deps); // Not explicitly declaring deps, because the list of "what changed" is the deps argument
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, Object.values(deps));
}